export default function Navbar() {
    //const dummy_footer = "Footer du Portfolio"

    return (
        <nav>
            <ul className="navbar">
                <li className="button-nav"><a href="#experience"> Mon parcours </a></li>
                <li className="button-nav"><a href="#projects"> Mes projets </a></li>
                <li className="button-nav"><a href="#contact"> Contact </a></li>
            </ul>
        </nav>
    )
}